import { lighten } from '@mui/material';
import { ComponentThemeType } from './theme.types';

declare module '@mui/material/Chip' {
  interface ChipPropsVariantOverrides {
    cancelled: true;
  }
}

export const chipsTheme: ComponentThemeType = {
  MuiChip: {
    styleOverrides: {
      filled: ({ ownerState: { color }, theme: { palette } }) => {
        let colorProp: 'default' | 'primary' | 'secondary' | 'tertiary' | 'error' | 'info' | 'success' | 'warning';
        let backgroundColor: any;
        switch (color) {
          case 'success':
            colorProp = 'success';
            backgroundColor = lighten(palette.success.light, 0.1);
            break;

          case 'secondary':
            colorProp = 'secondary';
            backgroundColor = lighten(palette.secondary.light, 0.75);
            break;

          case 'error':
            colorProp = 'error';
            backgroundColor = lighten(palette.error.light, 0.75);
            break;

          case 'info':
            colorProp = 'info';
            backgroundColor = lighten(palette.info.light, 0.75);
            break;

          case 'warning':
            colorProp = 'warning';
            backgroundColor = lighten(palette.warning.light, 0.25);
            break;

          case 'default':
            colorProp = 'secondary';
            backgroundColor = 'whitespoke';
            break;

          default:
            colorProp = 'tertiary';
            break;
        }

        return {
          backgroundColor: backgroundColor || palette[colorProp].light,
          color: palette[colorProp].main,
          fontWeight: 600,
        };
      },
    },
    variants: [
      {
        props: { variant: 'cancelled' },
        style: ({ theme: { palette } }) => ({
          backgroundColor: lighten(palette.primary.main, 0.9),
          color: palette.primary.dark,
          fontSize: 15,
        }),
      },
    ],
  },
};
